import { motion } from 'framer-motion';

export default function TheaterSection() {
  return (
    <section className="py-24 px-6 bg-white relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#101A2E]/5 to-transparent"></div>
      
      <div className="max-w-5xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <div className="inline-block mb-8">
            <div className="w-32 h-32 flex items-center justify-center rounded-3xl shadow-2xl mx-auto mb-6 overflow-hidden">
              <img
                src="img/mask.jpg"
                alt="Театральные маски"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-[#101A2E] mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Театр «Монплезир»
          </h2>
          
          <p className="text-lg text-[#D8B36A] font-semibold mb-6">
            Изюминка вечера
          </p>

          <div className="max-w-3xl mx-auto mb-10">
            <div className="relative w-full h-80 rounded-2xl overflow-hidden shadow-2xl mb-8">
              <img
                src="img/theatre.jpg"
                alt="Театр Монплезир - сцена"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#101A2E]/60 to-transparent"></div>
            </div>

            <div className="bg-white/80 backdrop-blur-md rounded-2xl p-8 border border-[#D8B36A]/20 shadow-lg">
              <p className="text-lg text-[#1E2430] leading-relaxed mb-4 text-justify">
                Лауреаты российских и международных фестивалей под художественным руководством <strong className="text-[#D8B36A]">Игоря Ларина</strong>.
              </p>
              <p className="text-base text-[#1E2430]/80 text-justify">
                Между научными дискуссиями вас ждут два мини-спектакля, которые создадут особую атмосферу петербургского вечера и позволят переключиться, сохранив при этом интеллектуальный настрой.
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center gap-8 text-sm text-[#1E2430]/60">
            <div className="flex items-center gap-2">
              <i className="ri-award-line text-[#D8B36A] text-xl"></i>
              <span>Лауреаты фестивалей</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-star-line text-[#D8B36A] text-xl"></i>
              <span>Профессиональная труппа</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}